import React, { Suspense } from 'react'
import { Loading } from '@pandiafi/design-system'

import { DataLoader } from './PaymentInformationDataLoader'
import { CommonPaymentInformation } from './CommonPaymentInformation'
import { BankAccountsPerCategory } from './BankAccountsPerCategory'
import { ErrorHandler } from './PaymentInformationErrorHandler'

export const PaymentInformation: React.FC = () => {
  return (
    <Suspense fallback={<Loading variant="details" />}>
      <ErrorHandler>
        <DataLoader>
          {({ paymentCategories, contract }) => (
            <>
              <CommonPaymentInformation contract={contract} />
              <BankAccountsPerCategory paymentCategories={paymentCategories} />
            </>
          )}
        </DataLoader>
      </ErrorHandler>
    </Suspense>
  )
}
